import styled from 'styled-components';

const LabelTd = styled.td`
  && {
    position: sticky;
    top: calc(2rem + 3px);
    vertical-align: top;
    border-top: 1px solid var(--border-color);
    border-bottom: none;
    background-color: #f8f8f8;
  }
  tr:first-of-type > & {
    border-top: none;
    top: calc(2rem + 4px);
  }
`;

const FillerTd = styled.td`
  border: none;
  background-color: #f8f8f8;
`;

// FillerTd is a workaround for position sticky in a table with a non-visible overflow.

const StickyGroupTd = ({ rowSpan, rowIdx, children }) => (
  <>
    {rowIdx === 0 && <LabelTd>{children}</LabelTd>}
    {rowIdx === 1 && <FillerTd rowSpan={rowSpan - 1} />}
  </>
);

export default StickyGroupTd;
